import { setupLogger } from '@zoopla/logger';
import {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    trackSegmentAndGAEvent,
    triggerTracking,
    EventNamesList
} from '@zoopla/tracking';
import { authTaxonomyObject } from '../constants/taxonomy';
import {
    // TODO: Observability replace with RUM solution
    // formatNewRelicErrorData,
    FacebookError,
    GoogleError,
    GoogleOneTapError
} from '../utils/formatNewRelicErrorData';
import { trackAuthSegmentEvent, User } from '../utils/segmentTrack';
import { SegmentTrackingData } from '../AuthModal.types';

type TrackingArgs = {
    userObject: User;
    type: 'registration' | 'signin';
    source: keyof typeof authTaxonomyObject;
    label?: string;
    segmentData: SegmentTrackingData;
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const eventTrackingMap: Record<string, EventNamesList> = {
    reg: 'Registration',
    signin: 'Sign In',
    optin: 'Email Marketing Opt-In'
};

const logger = setupLogger({
    component: 'authentication-modal',
    custodian: 'pnp'
});

export const trackAuthSuccess = ({
    userObject,
    type,
    source,
    label,
    segmentData
}: TrackingArgs) => {
    triggerTracking({
        event: 'GAEvent',
        eventCategory: type,
        eventAction: `success - ${source}`,
        eventLabel: label || 'sign_in_modal',
        taxonomy: authTaxonomyObject[source].signin
    });

    trackAuthSegmentEvent(
        type === 'registration' ? 'reg' : 'signin',
        segmentData,
        userObject
    );

    // TODO: Swap out tracking in CRME-2357
    // const taxonomy = {
    //     ...authTaxonomyObject[source][type],
    //     ...segmentData,
    //     brand: 'zoopla'
    // };

    // trackSegmentAndGAEvent(
    //     eventTrackingMap[type],
    //     {
    //         eventCategory: type,
    //         eventAction: `success - ${source}`,
    //         eventLabel: label || 'sign_in_modal'
    //     },
    //     segmentData?.page || 'sign_in_modal',
    //     taxonomy
    // );
};

export const trackAuthFailure = ({
    type,
    source,
    label
}: Omit<TrackingArgs, 'userObject'>) => {
    triggerTracking({
        event: 'GAEvent',
        eventCategory: type,
        eventAction: `failure_generic - ${source}`,
        eventLabel: label || 'sign_in_modal'
    });

    // TODO: Swap out tracking in CRME-2357
    // const taxonomy = {
    //     ...authTaxonomyObject[source][type],
    //     ...segmentData,
    //     brand: 'zoopla'
    // };

    // trackSegmentAndGAEvent(
    //     eventTrackingMap[type],
    //     {
    //         eventCategory: type,
    //         eventAction: `failure_generic - ${source}`,
    //         eventLabel: label || 'sign_in_modal'
    //     },
    //     segmentData?.page || 'sign_in_modal',
    //     taxonomy
    // );
};

export const trackAuthRememberMe = ({ type, source, label }: TrackingArgs) => {
    triggerTracking({
        event: 'GAEvent',
        eventCategory: type,
        eventAction: 'keep_me_signed_in',
        eventLabel: label || 'sign_in_modal',
        taxonomy: authTaxonomyObject[source].signin
    });

    // TODO: Swap out tracking in CRME-2357
};

export const trackNextBestActionOptin = (
    consent: boolean,
    page?: string | undefined
) => {
    trackSegmentAndGAEvent(
        consent ? 'Email Marketing Opt-In' : 'Module Interaction',
        {
            eventCategory: 'next_best_action',
            eventAction: consent ? 'yes' : 'no',
            eventLabel: 'email_marketing_opt_in'
        },
        page || '/homepage/'
    );
};

type RestrictedSupportedErrors =
    | FacebookError
    | GoogleError
    | GoogleOneTapError;

export const logAuthSuccess = (name: 'facebook-auth' | 'google-auth') => {
    // TODO: Observability replace with RUM solution
    // window.newrelic?.addPageAction(
    //     ...formatNewRelicSuccessData({
    //         name
    //     })
    // );
};

export const logSocialAuthFailure = (
    newRelicErrorData: RestrictedSupportedErrors
) => {
    const { name, type } = newRelicErrorData;

    if (process.env.NODE_ENV !== 'production') {
        logger.info(`${name} auth ${type}`);
    }

    // TODO: Observability replace with RUM solution
    // if (newRelicErrorData) {
    //     window.newrelic?.addPageAction(
    //         ...formatNewRelicErrorData(newRelicErrorData)
    //     );
    // }
};

type UserBackendServerErrorTypes =
    | 'register'
    | 'signin'
    | 'facebook'
    | 'google'
    | 'googleonetap';

export const logUserAuthFailure = ({
    subtype,
    type
}: {
    type: UserBackendServerErrorTypes;
    subtype: 'no_uuid' | 'not_logged_in';
}) => {
    if (process.env.NODE_ENV !== 'production') {
        logger.info(
            `user ${
                subtype === 'not_logged_in' ? 'not logged in' : 'uuid not found'
            }`
        );
    }

    // TODO: Observability replace with RUM solution
    // window.newrelic?.addPageAction(
    //     ...formatNewRelicErrorData({ name: 'user-error-auth', type, subtype })
    // );
};

export const logNetworkAuthFailure = ({
    type
}: {
    type: UserBackendServerErrorTypes;
}) => {
    if (process.env.NODE_ENV !== 'production') {
        logger.info('Network error');
    }

    // TODO: Observability replace with RUM solution
    // window.newrelic?.addPageAction(
    //     ...formatNewRelicErrorData({ name: 'network-error-auth', type })
    // );
};
